<template>
<div class="set-container" :class="medalClass">
    <!-- medal set -->
    <li v-if="isMedalSet(model)" class="card medal-set">
        <ImageViewer :images="getImageObjects()" :thumbnails="medalThumbnail()" :placeholder="{}" :card-layout="'horizontal'" />

        <ul id="links" :class="{'columns': medalNames(model).length > 4}">
            <li v-for="medal in medalNames(model)" v-bind:key="model.irn + medal">
                <router-link
                    class="medalField cardHeader"
                    :to="{name: 'medal', params: {slug: medalId(medal)}}">
                    {{ isMemorialSet(medal) ? $t('recipient_decorations.learn_more') : medal}}
                </router-link>
            </li>
        </ul>
    </li>

    <!-- single medal -->
    <li v-else
        class="card artifact"
        v-for="medal in medalNames(model)"
        v-bind:key="model.irn + medal">

        <ImageViewer :images="getImageObjects()" :thumbnails="medalThumbnail()" :placeholder="{}" :card-layout="'vertical'" />

        <div id="text">
            <div class="medals">
                <div>
                <router-link class="medalField cardHeader"
                    :to="{name: 'medal', params: {slug: medalId(medal)}}">
                    {{medal}}
                </router-link>
                </div>
            </div>
        </div>
    </li>
</div>
</template>

<script>
import {mapGetters} from "vuex"

import {medal_id} from '@/models/medal.js'
import {medal_set_names} from '@/models/medal.js'
import {medal_set_image} from '@/models/medal.js'
import {medal_set_thumb} from '@/models/medal.js'
import {medal_set_images} from '@/models/medal.js'
import {medal_is_set} from '@/models/medal.js'

import ImageViewer from '@/components/ImageViewer'

export default {
    name: "MedalSet",
    components: {
        ImageViewer
    },
    props: {
        model: Object,
        medals: Array
    },
    computed: {
        imgAlt() {
            return `Image of ${this.model.ObjDisplayName}`;
        },
        medalClass() {
            return medal_is_set(this.model) ? 'set' : 'individual'
        },
    },
    methods: {
        medalNames: (item => {
            return medal_set_names(item);
        }),
        medalId (name) {
            return medal_id(name, this.medals);
        },
        isMedalSet: ((model) => {
            return medal_is_set(model);
        }),
        isMemorialSet(medal){
            return medal === this.model.ObjDisplayName
        },
        medalImg() {
            return medal_set_image(this.model);
        },
        medalThumbnail() {
            return [medal_set_thumb(this.model)];
        },
        getImageObjects() {
            return this.model ? medal_set_images(this.model) : [];
        }
    }
}
</script>

<style lang="scss" scoped>

.set-container {
    margin-bottom: 15px; 
    margin-right: 15px;
}

.standinImage {
    width: 200px;
    height: auto;
}

.cardHeader {
    &:after {
        display: none;
    }
}

.card {
    height: 280px;

    a {
        color: #4a4a4a;
        font-size: 13px;
        line-height: 16px;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        font-weight: bold;
        text-decoration: none;
        margin-bottom: 12px;
        width: 180px;
        display: block;

        &:hover {
            text-decoration: underline;
        }
    }

    .thumbnailImage {
        width: initial;
        min-width: initial;
        overflow: hidden;
        background-color: #fff;

        img {
            height: 260px;
            width: fit-content;
            margin-right: 15px;
        }
    }

    &.medal-set {
        margin-bottom: 15px;
        width: 100%;
        width: fit-content;
        position: relative;
        display: flex;

        .thumbnailImage {
            width: 40%;
            min-width: 200px;
            height: 100%;
        }

        #text {
            padding-left: 20px;

            .medals {
                list-style: none;
                margin: 0;
                padding: 0;

                &.columns {
                    column-count: 2;
                }
            }
        }
    }
}

.individual {
    margin-right: 15px;
}

.set {
    margin-right: 15px;
    ul#links {
        list-style: none;
        padding-left: 15px;

        &.columns {
            columns: 2;

            li {
                -webkit-column-break-inside: avoid;
                page-break-inside: avoid;
                break-inside: avoid;
            }
        }

    }
    @media screen and (max-width: 940px) {
        .card {
            width: 100%;
            width: fit-content;
            height: initial;

            ul#links {
                flex-direction: column;
                flex-wrap: nowrap;
                height: initial;

                &.columns {
                    columns: 1;
                }
            }
        }
    }
    @media screen and (max-width: 650px) {
        .card {
            width: 100%;
            width: fit-content;
            flex-direction: column;
            flex-wrap: nowrap;
            height: initial;

            ul#links {
                margin-top: 15px;
                flex-direction: column;
                flex-wrap: nowrap;
                height: initial;

                &.columns {
                    columns: 1;
                }
            }
        }
    }
}
@media screen and (max-width: 650px) {
    .set .card {
        padding: 0;
    }
}

.artifact {
    width: initial;

    .cardHeader {
        margin-top: 0;
    }

    #text {
        margin-top: 20px;
    }

    .thumbnailImage {
        overflow: hidden;
        height: 220px;

        img {
            height: 100%;
            width: 100%;
            width: fit-content;
            display: block;
            margin: 0 auto;
        }
    }
}
</style>